(function () {
    var SelectPeriodCtrl = (function () {
        function SelectPeriodCtrl() {
            this.init.apply(this, arguments);
        }

        SelectPeriodCtrl.prototype = {
            init: function ($scope, $mdDialog, $mdPanel, $translationService, AuthService, $state, $Config, titleKey, startDate, endDate) {
                $scope.vm = this;
                this.$scope = $scope;
                this.$mdDialog = $mdDialog;
                this.$mdPanel = $mdPanel;
                this.$translationService = $translationService;
                this.authService = AuthService;
                this.$state = $state;
                this.$Config = $Config;

                this.titleKey = titleKey;
                // moment-picker work better on string so we need to format
                this.startDate = moment(startDate).format('DD/MM/YYYY');
                this.endDate = moment(endDate).format('DD/MM/YYYY');;

                // console.log('start ', this.startDate);
                // console.log('end ', this.endDate);
                
            },
            ok: function () {
                this.$mdDialog.hide({
                    startDate: moment(this.startDate, 'DD/MM/YYYY').toDate(), 
                    endDate: moment(this.endDate, 'DD/MM/YYYY').toDate()
                });
            },
            cancel: function () {
                this.$mdDialog.cancel();
            }
        };
        SelectPeriodCtrl.$inject = [
            '$scope',
            '$mdDialog',
            '$mdPanel',
            '$translationService',
            'AuthService',            
            '$state',
            '$Config',
            'titleKey',
            'startDate',
            'endDate'
        ];
        return SelectPeriodCtrl;
    }());
    angular.module('shared.select-period', []).controller('SelectPeriodCtrl', SelectPeriodCtrl);
})();